(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["notch-product-card"] && !Shopify.designMode) return;
  try {
    /**
   * Size selection on a range tile.
   *
   * The script does exactly one thing: show the pane belonging to the checked
   * size. Everything else — which chip reads as chosen, which plan panel is
   * emphasised, which of the two links is on screen — is CSS keyed on
   * :checked, and every price and href is server-rendered. So there is no
   * client-side price formatting to drift from Shopify's `money` filter, and
   * no state to reconcile.
   *
   * The `--live` class is the honesty gate. Until it is added, CSS makes the
   * chips inert, because a chip that moves the emphasis without swapping the
   * pane would show one size's price under another size's name.
   */
  (() => {
    const wire = (card) => {
      if (card.classList.contains('notch-pcard--live')) return;
      const panes = [...card.querySelectorAll('[data-notch-card-pane]')];
      const sizes = [...card.querySelectorAll('[data-notch-card-size]')];
      // One pane is nothing to swap between, so the chips stay inert rather
      // than becoming a control with a single position.
      if (panes.length < 2 || sizes.length < 2) return;

      const show = () => {
        const id = sizes.find((r) => r.checked)?.value;
        if (!id) return;
        panes.forEach((pane) => {
          pane.hidden = pane.dataset.notchCardPane !== id;
        });
      };

      /**
       * Keep the plan choice across a size change.
       *
       * Each pane owns its own plan group, because one group shared across
       * panes can hold only one checked radio and the visible pane would
       * routinely be the one holding none. The cost is that panes can
       * disagree: pick 90, pick One-time, go back to 72, and 72 is still on
       * the Subscribe it was rendered with — so changing SIZE looked like it
       * was changing the plan. It never was; you were being shown another
       * pane's untouched answer.
       *
       * The plan is a property of the purchase, not of the pack, so a choice
       * made in one pane is written to all of them. A pane with no
       * subscription keeps its own default rather than being set to a plan it
       * does not offer.
       */
      const mirror = (event) => {
        const want = event.target.value;
        panes.forEach((pane) => {
          const match = pane.querySelector(
            `.notch-pcard__plan-input[value="${want}"]`
          );
          if (match) match.checked = true;
        });
      };

      sizes.forEach((r) => r.addEventListener('change', show));
      card
        .querySelectorAll('.notch-pcard__plan-input')
        .forEach((r) => r.addEventListener('change', mirror));
      card.classList.add('notch-pcard--live');
      show();
    };

    const boot = (root) =>
      (root || document).querySelectorAll('.notch-pcard').forEach(wire);

    document.addEventListener('DOMContentLoaded', () => boot());
    if (document.readyState !== 'loading') boot();
    // The theme editor tears a section down and rebuilds it; without this the
    // chips stop working the moment a merchant edits the grid.
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
